import React from 'react';
import './Breadcrumbs.css';
import { useParams, useNavigate } from 'react-router-dom';

const separatorIcon = <span className="dcip-breadcrumbs-separator">/</span>;

const backIcon = (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
    >
        <path d="M15 18l-6-6 6-6" />
    </svg>
);

const Breadcrumbs: React.FC<any> = ({ setSearchValue = () => {} }) => {
    const navigate = useNavigate();
    const currentLocale =
        (window as any)?.Liferay?.ThemeDisplay?.getBCP47LanguageId?.() ||
        'en-US';

    const {
        categoryId,
        taxonomyCategoryIds,
        taxonomySubCategoryIds,
        partnerId,
        parterToOfferId
    } = useParams<{
        categoryId?: string;
        taxonomyCategoryIds?: string;
        taxonomySubCategoryIds?: string;
        partnerId?: string;
        parterToOfferId?: string;
    }>();

    /* -------- session labels -------- */
    const selectedCategory = JSON.parse(
        sessionStorage.getItem('selectedCategory') || 'null'
    );

    const selectedService = JSON.parse(
        sessionStorage.getItem('selectedServiceItem') || 'null'
    );

    const selectedSubService = JSON.parse(
        sessionStorage.getItem('selectedSubServiceItem') || 'null'
    );

    const selectedPartner = JSON.parse(
        sessionStorage.getItem('selectedPartner') || 'null'
    );

    const selectedOffer = JSON.parse(
        sessionStorage.getItem('selectedOffer') || 'null'
    );

    const getLabelFromSession = (
        item: any,
        key: string,
        fallback: string,
        englishFallbackKey?: string
    ) => {
        if (!item) return fallback;

        const localeMatch =
            !item?.locale ||
            String(item.locale).toLowerCase() ===
                String(currentLocale).toLowerCase();

        if (localeMatch && item?.[key]) {
            return item[key];
        }

        if (englishFallbackKey && item?.[englishFallbackKey]) {
            return item[englishFallbackKey];
        }

        return localeMatch ? item?.[key] || fallback : fallback;
    };

    /* -------- breadcrumbs -------- */
    const breadcrumbs: Array<{ label: string; to?: string }> = [];

    /* ---------- Category ---------- */
    if (categoryId) {
        breadcrumbs.push({
            label: getLabelFromSession(
                selectedCategory,
                'name',
                'Category',
                'englishName'
            ),
            to: `/categories/${categoryId}`
        });
    }

    /* ---------- Service ---------- */
    if (taxonomyCategoryIds) {
        breadcrumbs.push({
            label: getLabelFromSession(selectedService, 'title', 'Service'),
            to: `/categories/${categoryId}/${taxonomyCategoryIds}`
        });
    }

    /* ----------Sub Service ---------- */
    if (taxonomySubCategoryIds) {
        breadcrumbs.push({
            label: getLabelFromSession(
                selectedSubService,
                'title',
                'Sub Service'
            ),
            to: `/categories/${categoryId}/${taxonomyCategoryIds}/${taxonomySubCategoryIds}`
        });
    }

    /* ---------- Partner ---------- */
    if (partnerId) {
        breadcrumbs.push({
            label: getLabelFromSession(selectedPartner, 'name', 'Partner'),
            to: `/categories/${categoryId}/${taxonomyCategoryIds}/${taxonomySubCategoryIds}/${partnerId}`
        });
    }

    /* ---------- Offer ---------- */
    if (parterToOfferId) {
        breadcrumbs.push({
            label: getLabelFromSession(selectedOffer, 'title', 'Offer')
        });
    }

    /* -------- render -------- */
    return (
        <nav aria-label="Breadcrumb" className="dcip-breadcrumbs">
            <div className="dcip-breadcrumbs-wrapper">
                {/* Back Arrow */}
                <button
                    className="dcip-breadcrumbs-back"
                    onClick={() => {
                        navigate(-1);
                        setSearchValue('');
                    }}
                >
                    {backIcon}
                </button>

                <ol className="dcip-breadcrumbs-list">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;

                        return (
                            <li
                                key={`${crumb.label}-${index}`}
                                className="dcip-breadcrumbs-item"
                            >
                                {!isLast && crumb.to ? (
                                    <>
                                        <div
                                            className="breadCrumbs-link"
                                            onClick={() => {
                                                setSearchValue('');
                                                navigate(crumb.to!);
                                            }}
                                        >
                                            {crumb.label}
                                        </div>
                                        {separatorIcon}
                                    </>
                                ) : (
                                    <span aria-current="page">
                                        {crumb.label}
                                    </span>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </div>
        </nav>
    );
};;;

export default Breadcrumbs;